import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { getAccessTypes, GetResponseAccessTypes } from '../../services';

export function useAccessTypes(
  type: string,
  options: UseQueryOptions<GetResponseAccessTypes[], unknown> = {},
): UseQueryResult<GetResponseAccessTypes[], unknown> {
  return useQuery<GetResponseAccessTypes[], unknown>(
    ['accessTypes'],
    () => getAccessTypes(type),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
